module.exports = __webpack_public_path__ + "img/pic@2x.ed2d5c2f.png";